import ReactCropper from "react-cropper";
import { Dialog, DialogClose, DialogContent } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

export const CropperModal = ({
  image,
  setCropper,
  isOpenModal,
  setIsOpenModal,
  onSave,
  aspectRatio,
}) => {
  function closeModal() {
    setIsOpenModal(false);
  }

  function saveHandler() {
    onSave();
    setIsOpenModal(false);
  }

  return (
    <Dialog open={isOpenModal} onOpenChange={closeModal}>
      <DialogContent
        className={"w-[336px] md:w-[522px]"}
        innerClassName={"px-6 py-10 "}
      >
        <div className={"mb-6"}>
          <div className={`text-foreground mb-1.5 text-lg font-semibold`}>
            Edytuj okładkę
          </div>
          <div className={`text-muted-foreground text-sm font-normal`}>
            Możesz przyciąć grafikę, przeciągając krawędzie.
          </div>
        </div>
        <ReactCropper
          src={image}
          style={{ height: 400, width: "100%" }}
          viewMode={1}
          aspectRatio={aspectRatio}
          cropBoxResizable={true}
          cropBoxMovable={true}
          center={true}
          checkOrientation={true}
          onInitialized={(instance) => setCropper(instance)}
          autoCropArea={1}
        />

        <div className={"mt-6 flex items-center justify-between"}>
          <Button onClick={saveHandler} variant={"blue"}>
            Akceptuj
          </Button>
          <Button variant={"outline"} onClick={closeModal}>
            Anuluj
          </Button>
        </div>
        <DialogClose />
      </DialogContent>
    </Dialog>
  );
};
